seedWebApp.controller('ProcExpsController', ['$scope', '$rootScope', 'StoreService', '$uibModal', 'ToastService', 'TranslationService',
    function ($scope, $rootScope, StoreService, $uibModal, ToastService, TranslationService) {

        $scope.translation = TranslationService.getActiveTranslation();
        $scope.prefs = {
            name: 'SalesRepsGrid',
            sortByCol: null,
            canAdd: false,
            canEdit: true,
            canDelete: false,
        };

        $scope.getIDClass = function (item) {
            return 'agp-color';
        };

        $scope.columns = [
            { name: 'ProcExpID', display: 'ID', orderBy: 'asc', editable: false, width: 5, isKey: true, customClass: $scope.getIDClass },
            { name: 'ProcExpName', display: 'Nome', editable: true, width: 15 },
            { name: 'PlantID', display: 'Planta', editable: true, width: 10 },
            { name: 'RouteID', display: 'Itinerário', editable: true, width: 5 },
            { name: 'ControlPoint', display: 'Pto Controle', editable: true, width: 5 },
            { name: 'ForecastDate', display: 'Dt Prevista', editable: true, width: 5, dataType: 'date', format: 'dd/MM/yyyy' },
            { name: 'ActualDate', display: 'Dt Efetiva', editable: true, width: 5, dataType: 'date', format: 'dd/MM/yyyy' },

            //{ name: 'IsActive', display: 'Ativo', editable: true, width: 5, dataType: 'boolean' },
            //{ name: 'IsActive', display: 'Ativo', dataType: 'boolean', filterOptions: [], width: 5 },
        ];

        //$scope.prefs.sortByCol = $scope.columns[0];
        //$scope.prefs.sortByCol.orderReverse = false;

        $scope.loadService = StoreService.getProcExps;
        $scope.resetService = StoreService.resetCache;
        //$scope.loadColumns = ContactService.getContactsColumns;

        $scope.getTotal = function () {
            $scope.loadingTotal = true;
            StoreService.getProcExpsCount().then(function (response) {
                $scope.loadingTotal = false;
                if (response) {
                    $scope.totalItems = response.data.TotalCount;
                    //$scope.lastSync = response.data.LastSync;
                }

            });
        };

        $scope.getTotal();

        $scope.searchMode = function () {
            $scope.$broadcast('inputSearch', $scope.filterString);
        };

        $scope.doRefresh = function () {
            $scope.$broadcast('refreshServiceGrid');
        };

        $scope.toExcel = function () {
            $scope.$broadcast('toExcel', 'procExps');
        };

        $scope.doInsert = function () {
            $scope.$broadcast('addItem');
        };

        $scope.prefs.customEdit = function (item) {
            /*
            if (!contact) {
                contact = { ContactID: 'ADD_NEW' };
            } else {
                contact.BlockedDate = new Date(contact.BlockedDate);
                contact.CertificateExpirationDate = new Date(contact.CertificateExpirationDate);
            }
            */
            var modalInstance = $uibModal.open({
                templateUrl: '/SPA/Orders/procExpModal.html',
                controller: 'ProcExpCtrl',
                size: 'lg',
                resolve: {
                    item: function () {
                        return item;
                    }
                }
            });
            modalInstance.result.then(function (contact) {
                console.log('saving....');
            });
        };

        //$(document).ready(function () {
        //    $scope.overflowSize = $scope.AdjustSize();
        //});

    }]);
